module.exports = __webpack_public_path__ + "static/media/CharlesThomas02.51d4ab30.jpg";